export const SEARCH_TAB_ITEMS = [
    { value: 'all', label: '전체' },
    { value: 'seller', label: '판매자' },
    { value: 'live', label: '라이브' },
    { value: 'scheduledLive', label: '예정 라이브' },
];
export const SEARCH_SCREEN_FIELDS = [
    {
        key: 'search.tabs.order',
        group: '탭',
        label: '탭 순서',
        help: '검색 화면 위 탭(전체·판매자·라이브·예정 라이브)의 순서. 검색 화면을 열면 맨 앞 탭이 선택된다',
        type: 'order',
        defaultValue: SEARCH_TAB_ITEMS.map((item) => item.value),
        items: SEARCH_TAB_ITEMS,
    },
    {
        key: 'search.tabs.layout',
        group: '탭',
        label: '탭 배치',
        help: '한 줄 가로 스크롤: 화면을 넘는 탭은 옆으로 밀어 본다. 줄바꿈: 넘치는 탭을 다음 줄에 놓는다',
        type: 'enum',
        defaultValue: 'scroll',
        options: [
            { value: 'scroll', label: '한 줄 가로 스크롤' },
            { value: 'wrap', label: '줄바꿈' },
        ],
    },
    {
        key: 'search.sort.visible',
        group: '탭',
        label: '정렬 버튼 노출',
        help: '끄면 검색 화면 탭 줄 맨 앞의 정렬 버튼을 그리지 않는다',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=search.js.map